import { Box, type BoxProps } from "@chakra-ui/react";
import type React from "react";

import { CONFIG } from "@/constants/config";

const EnvironmentMap = {
  local: {
    color: "gray.400",
    label: "Local",
  },
  dev: {
    color: "green.400",
    label: "Dev",
  },
  staging: {
    color: "yellow.400",
    label: "Staging",
  },
  demo: {
    color: "blue.400",
    label: "Demo",
  },
};

export function EnvironmentTopStrip() {
  const env = EnvironmentMap[CONFIG.ENV as keyof typeof EnvironmentMap];
  if (!env) return null;

  return <Box w="100vw" zIndex="modal" pos="fixed" bg={env.color} h="6px" />;
}

export const EnvironmentCard: React.FC<
  BoxProps & { fallback?: React.ReactNode }
> = ({ fallback = null, ...props }) => {
  const environment = EnvironmentMap[CONFIG.ENV as keyof typeof EnvironmentMap];
  if (!environment) return fallback;

  return (
    <Box
      w="calc(100% - 56px)"
      mx="auto"
      py="1"
      borderRadius="md"
      textAlign="center"
      textStyle="h2"
      bg={environment.color}
      textTransform="uppercase"
      maxW="32"
      color="white"
      {...props}>
      {environment.label}
    </Box>
  );
};
